export default __webpack_public_path__ + "static/media/icon-liquid.662d5557.svg";